import { useEffect } from "react";

type DataLayer = unknown[];

export function useGoogleTagManager(gtmId: string): void {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    // Initialize dataLayer if it doesn't exist
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    // Check if GTM is already loaded
    const existingScript = document.querySelector(
      `script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`,
    );

    if (existingScript) {
      return;
    }

    // Push GTM start event
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": Date.now(),
    });

    // Create and insert the GTM script
    const script = document.createElement("script");

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

    const firstScript = document.querySelectorAll("script")[0];

    firstScript?.parentNode?.insertBefore(script, firstScript);

    // Create and insert the noscript iframe for GTM
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");

    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.append(iframe);

    // Insert noscript after opening body tag
    document.body.prepend(noscript);

    return () => {
      // Cleanup: remove script and noscript on unmount
      const s = document.querySelector(
        `script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`,
      );

      s?.remove();

      const ns = document.querySelector(
        `noscript iframe[src*="googletagmanager.com/ns.html?id=${gtmId}"]`,
      );

      ns?.parentElement?.remove();
    };
  }, [gtmId]);
}

declare global {
  interface Window {
    dataLayer?: DataLayer;
  }
}
